import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';

import { Box, Stack } from '@mui/material';

import { ViewItem, FormCard } from '@/components';
import { PageBackHeader } from '@/layouts/TabLayout';
import { towingCompaniesDummyData } from '@/pages/Tools/TowingManagement/data';

export const TowingCompanyDetailsPage = () => {
  const { id } = useParams();
  const [company, setCompany] = useState<any | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const match = towingCompaniesDummyData.find((c) => c.id === Number(id));
    if (match) setCompany(match);
  }, [id]);

  if (!company) return null;

  const onGoBack = () => {
    const searchValue = searchParams.get('search');
    const searchQuery = searchValue
      ? `&search=${encodeURIComponent(searchValue)}`
      : '';
    navigate(`/tools/towing-management?tab=companies${searchQuery}`);
  };

  return (
    <>
      <PageBackHeader
        title="View Towing Company"
        goBack={onGoBack}
        style={{
          fontWeight: 600,
          fontSize: '20px',
        }}
      ></PageBackHeader>
      <Stack overflow="auto">
        <Box sx={{ borderRadius: 2, p: 3 }}>
          <FormCard title="Towing Company Overview" className="grey-title">
            <ViewItem
              label="Company Name"
              value={company.company}
              md={12}
              copyable
            />
            <ViewItem label="Status" value={company.status} md={6} copyable />
            <ViewItem
              label="Phone Number"
              value={company.phoneNumber}
              md={6}
              copyable
            />
            <ViewItem
              label="Service Area"
              value={company.serviceArea}
              md={6}
              copyable
            />
            <ViewItem
              label="Last Used"
              value={company.lastUsed}
              md={6}
              copyable
            />
            <ViewItem
              label="Address"
              value={company.address}
              md={12}
              copyable
              sx={{ '.value': { textTransform: 'none', flex: 'unset' } }}
            />
          </FormCard>
        </Box>
      </Stack>
    </>
  );
};
